import React from "react";
import { Controller } from "react-hook-form";
import { useFormContext } from "./FormProvider";
import PropTypes from "prop-types";
import { Checkbox } from "../Checkbox/Checkbox";
import { createStyles } from "antd-style";

const useStyles = createStyles(({ css }) => ({
  checkBox: css`
    .ant-form-item {
      .ant-row {
        justify-content: end;
      }
    }
  `,
}));

export const FormCheckBox = ({ name, helperText, ...props }) => {
  const { control, formConfig } = useFormContext();
  const { styles } = useStyles();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <div className={styles.checkBox}>
          <Checkbox
            {...field}
            {...formConfig}
            {...props}
            checked={field.value}
            error={!!error}
            helperText={error?.message || helperText}
            style={{ 
              justifyContent: "end",
              ...props.style 
            }}
          />
        </div>
      )}
    />
  );
};

FormCheckBox.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  helperText: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  style: PropTypes.object,
};